import cn from 'classnames';
import { FC } from 'react';
import { Typography } from 'src/components/common/Typography';
import { useI18n } from 'src/hooks/use-i18n-translation';
import { MediaManager } from 'src/manager/MediaManager';
import './styles.scss';

type Props = {
  settings: {
    priority: number;
    image: string;
    styles: Styles;
    text: { [key: string]: string };
    imageSourceCft?: string;
    classes: string;
  };
};
const AgeInfo: FC<Props> = ({ settings }) => {
  const { image, styles, text, classes, imageSourceCft } = settings;

  const { locale } = useI18n();

  return (
    <div
      className={cn('ageInfo_container', classes, { 'ageInfo_container--stacked': !!imageSourceCft })}
      style={styles}
    >
      <div className="ageInfo_row">
        <img src={MediaManager.getSrcFromMediaAssets(image, '/footerIcons/')} alt="Age info" />
        <Typography className="label" variant={'h6'} component="p">
          {text?.[locale]}
        </Typography>
      </div>
      {imageSourceCft && (
        <img
          className="ageInfo_source"
          src={MediaManager.getSrcFromMediaAssets(imageSourceCft, '/footerIcons/')}
          alt="Age info source"
        />
      )}
    </div>
  );
};
export default AgeInfo;
